import { useToast } from '@shared/ui/components/Toast';

export function useApiErrorToast() {
  const { toast } = useToast();

  return (error: any) => {
    if (!error.response) {
      return;
    }

    if (error.response.status === 422) {
      return;
    }

    const message = error.response.data?.message || error.message;

    toast({
      title: 'Something went wrong',
      description: message,
      variant: 'destructive',
    });
  };
}
